import React from 'react';
import PropTypes from 'prop-types';
import BaseOverlay from 'react-overlays/Overlay';
import placementOptions from '../placementOptions';

/**
 * @typedef Props
 * @prop {(x: {}) => void} children
 * @prop {boolean} [show]
 * @prop {'auto' | 'top' | 'right' | 'bottom' | 'left'} [placement]
 * @prop {boolean} [rootClose]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
// VERIFY OTHER PROPS ARE PASSED AS INTENDED
const MotifTooltipOverlay = props => {
  const { children, ...other } = props;

  return (
    <BaseOverlay {...other}>
      {({ props: overlayProps, arrowProps, show, ...baseProps }) =>
        children({
          ...baseProps,
          ...overlayProps,
          show,
          arrowProps
        })
      }
    </BaseOverlay>
  );
};

MotifTooltipOverlay.propTypes = {
  show: PropTypes.bool,
  rootClose: PropTypes.bool,
  placement: PropTypes.oneOf(placementOptions),
  children: PropTypes.func
};

export default MotifTooltipOverlay;
